<template>
  <el-table-column
    prop="birth_date"
    label="Születési idő"
    sortable="custom"
    min-width="180"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <span v-if="scope.row.birth_date">{{ scope.row.birth_date | date }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'birth_date',
  };
</script>
